import * as tslib_1 from "tslib";
import { BaseModel } from '../../_base/crud';
import { Role } from './role.model';
var User = /** @class */ (function (_super) {
    tslib_1.__extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    User.prototype.clear = function () {
        this.user_id = undefined;
        this.password = '';
        this.mobile = '';
        this.full_name = '';
        this.role_id = '';
        this.driver_company_id = null;
        this.cashier_area_id = null;
        this.s3_id = '';
        this.blocked = null;
        this.block_reason = '';
        this.role = new Role;
        this.role.clear();
        this.shift_id = '';
        this.company = '';
        this.pic = '';
    };
    return User;
}(BaseModel));
export { User };
